import type { AudioData } from 'ricos-schema';
import { Node_Type } from 'ricos-schema';

import type { NodeBuilder } from './types';

export const audio = (...args: (NodeBuilder | AudioData)[]): NodeBuilder => {
  const audioData = args.find((a): a is AudioData => !('type' in a));
  const nodeBuilders = args.filter((a): a is NodeBuilder => 'type' in a && a.type === 'block_node');

  return {
    type: 'block_node',
    // @ts-expect-error
    node: getId => ({
      id: getId(),
      type: Node_Type.AUDIO,
      ...(nodeBuilders.length && {
        nodes: nodeBuilders.map(nb => nb.node(getId)),
      }),
      audioData: audioData ? audioData : {},
    }),
  };
};
